module.exports = __webpack_public_path__ + "static/img/2-msg.53a3a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2-msg.png
// module id = Phpa
// module chunks = 1